<template>
  <section class="quotewizard">
    <div class="container">
      <br /><br />
      <div class="fieldleft">
        {{ quote.address.firstName }} {{ quote.address.lastName }}<br />
        <p>
          {{ quote.address.address }}<br />
          {{ quote.address.city }}, {{ quote.address.state.short }}
          {{ quote.address.zip }}
        </p>
      </div>
      <div class="fieldright" style="text-align: right">
        {{ date }}
      </div>
      <div style="clear: both"></div>
      <template v-if="quote.info.isManufactured">
        <div class="textheader">Notice of Adverse Underwriting Decision</div>
        <div class="textheader">CALIFORNIA</div>
        <br />
        <p>
          You have been declined insurance coverage, because of the answer(s)
          you have provided to the question(s) on your application for
          insurance.
        </p>
        <p class="indent">
          On your application for insurance you disclosed that the dwelling type
          is a manufactured/mobile home. Manufactured/mobile homes are
          unacceptable risks for our Renters Insurance Program.
        </p>
        <div class="textsubheader">Access to recorded personal information</div>
        <p>Upon your written request and submission of proper identification</p>
        <ul>
          <li>
            Within 30 business days of the receipt of your request to access to
            your recorded personal information, Assurant will inform you of the
            nature and substance of the recorded personal information in
            writing.
          </li>
          <li>
            You have the right to see and copy personal information in person or
            obtain a copy by mail. The information must be reasonably described
            by you and reasonably locatable and retrievable by us. Any
            information we provide you will be in plain language.
          </li>
          <li>
            If recorded, we will disclose the identity of those persons or
            institutional sources who gave us information within two (2) years
            prior to your request. If not recorded, we will disclose the names
            of those to whom such information is normally disclosed.
          </li>
          <li>
            You may request correction, amendment, or deletion of recorded
            personal information by submitting written request to:
            <div class="indent">
              Assurant<br />
              11222 Quail Roost Drive<br />
              Miami, FL 33157
            </div>
          </li>
        </ul>
        <div class="textsubheader">
          Request to correct, amend, or delete recorded personal information
        </div>
        <p>
          Within 30 business days from the date of receipt of your written
          request to correct, amend, or delete any recorded personal
          information, we must:
        </p>
        <ol>
          <li>
            Correct, amend or delete the portion of the recorded personal
            information in dispute; or
          </li>
          <li>
            Notify you of our refusal to make the correction, amendment or
            deletion, and the reason(s), for the refusal, and your right to file
            a statement if you disagree.
          </li>
        </ol>
        <p>If we refuse to make a correction, amendment or deletion:</p>
        <ol>
          <li>
            You have the right to file a concise statement with us. Your
            statement: (a) must set forth what you believe to be the correct,
            relevant, or fair information and, (b) explain why you disagree with
            our refusal.
          </li>
          <li>
            We will file your statement with any disputed personal information
            and make it accessible so that anyone reviewing the information will
            be cognizant of your statement.
          </li>
          <li>
            Furthermore, your statement will be with any subsequent disclosure.
          </li>
        </ol>
        <p>
          If the information is corrected, amended or deleted, the changes will
          be in writing and provided to you, any person who may have received
          the incorrect information within the preceding two years, any
          insurance-support organization that received the information within
          the preceding seven years, and any insurance support organization that
          furnished the personal information that has been corrected, amended or
          deleted.
        </p>
        <p>
          If you would like additional information concerning this action, you
          have 180 days to submit a written request to:
        </p>
        <p class="indent">
          Assurant<br />
          Privacy Office<br />
          Adverse Underwriting Decision<br />
          11222 Quail Roost Drive<br />
          Miami, FL 33157-6596
        </p>
        <p>
          We will respond to all written requests for additional information
          within 21 business days.
        </p>
        <p>
          California FAIR Plan Association: You may obtain insurance through
          another company in the voluntary market. If you have difficulty in
          procuring coverage in the voluntary market, you possibly may obtain
          basic fire insurance coverages through the California Fair Plan
          Association. Insurance through the Association is available only in
          certain areas of the state. For further information or assistance in
          obtaining basic property insurance through the FAIR Plan, please
          contact your agent or broker or the Plan at 1-213-487-0111 or
          1-800-339-4099 (in California only) or at the following website:
          www.cfpnet.com.
        </p>
      </template>
      <template v-else>
        <div class="textsubheader" style="font-size: 22px; text-align: center">
          California
        </div>
        <br />
        <div class="textheader" style="font-size: 22px">
          We are unable to process your application on our website as we need
          additional information.
        </div>
        <br />
        <p>
          Please email our Underwriting Department at
          <a href="mailto:property.underwriting@assurant.com" target="_blank"
            >property.underwriting@assurant.com</a
          >
        </p>
        <p class="indent">
          **Please include the following in your email:<br />
          <br /><b>"Renters Policy"</b> in the subject line and in the body of
          the email state the following:
          <b>
            "Requesting to obtain the Renters Application and Prior Loss History
            form'.
          </b>
        </p>
        <p>
          Once the completed application is received by our Underwriting
          Department we will notify you as to whether coverage will be provided.
        </p>
        <br />
        <br />
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { computed } from "vue";
import { useQuoteStore } from "@/stores/root/quote";

const title = "Notice of adverse";
//const saveStorage = store.dispatch("saveStorage");-----------
const quote = useQuoteStore();

onMounted(() => {
  quote.done = true;
});

const date = computed(() => {
  const today = new Date();
  return today.toLocaleDateString();
});
</script>
